<div class="modal-wrapper sm:max-w-md md:max-w-xl px-6 py-0!">

    <!-- When the date is confirmed -->
    <div *ngIf="currentSelectionTab === 'confirm'" class="py-6">
        <!-- header icon -->
        <img src="assets/icons/info-yellow.svg" alt="Icon" class="mb-6 mx-auto w-20 h-20" />

        <h3 class="mb-4 modal-title">{{ 'DATE_MODAL.CONFIRM_DATE_TITLE' | translate }}</h3>
        <p class="mb-6 text-(--text-muted) text-center font-medium leading-6 text-base mx-2">
            {{ 'DATE_MODAL.DATE_SELECTED_IS' | translate }} <span dir="ltr">{{ selectedDate | date:'dd MMM yyyy' }}</span>.<br/>
            {{ 'DATE_MODAL.CONFIRM_DESIRED_DATE' | translate }}
        </p>

        <!-- Confirm date -->
        <app-button [text]="'DATE_MODAL.CONFIRM' | translate" type="button" variant="primary" size="lg" (action)="confirmDate()"></app-button>

        <!-- Go back -->
        <app-button [text]="'DATE_MODAL.GO_BACK' | translate" type="button" variant="outline" size="lg" (action)="goBack()"
            extraClass="mt-5"></app-button>
    </div>

    <!-- When the date is not confirmed -->
    <div *ngIf="currentSelectionTab !== 'confirm'">
        <div class="flex items-center pt-6 pb-4 border-b-[0.5px] border-[#DAE1E4]">
            <h3 class="modal-title">
                {{options.headerTitle | translate}}</h3>
            <!-- Cancel Icon -->
            <img src="assets/icons/cancel.svg" alt="Cancel Icon" class="modal-close-icon rtl:mr-auto! rtl:ml-0!" (click)="close()" />
        </div>

        <div class="py-4 w-full max-w-lg mx-auto" (click)="$event.stopPropagation()">

            <!-- Header – Pill + Arrows -->
            <div class="flex items-center justify-center mb-6 px-2 gap-8" *ngIf="options.defaultSelection === 'all' || options.defaultSelection === 'date'">
                <!-- left arrow – go to previous tab -->
                <button type="button" (click)="goNextTab()" [disabled]="!canGoNext"
                    class="rounded-full hover:bg-gray-100 disabled:opacity-50 disabled:cursor-auto transition-opacity order-1 rtl:order-3" 
                    [attr.aria-label]="'Previous ' + currentSelectionTab">
                    <img [src]="canGoNext ? 'assets/icons/arrow-left-black.svg' : 'assets/icons/arrow-left-grey.svg'"
                        alt="arrow left" class="w-4 h-4" />
                </button>

                <!-- date pill -->
                <p dir="ltr"
                    class="inline-block px-4 py-1.5 bg-white text-xl text-center font-semibold border border-(--brand-primary) shadow-(--shadow-input) rounded-2xl max-w-[250px] w-full order-2">
                    <span [ngClass]="{
            'text-(--brand-primary)': currentSelectionTab === 'day',
            'text-(--text-secondary)': isDaySelected && currentSelectionTab !== 'day',
            'text-(--text-placeholder)': !isDaySelected && currentSelectionTab !== 'day'
          }">{{ day || 'DD' }}</span>
                    <span [ngClass]="{
            'text-(--text-secondary)': isDaySelected && isMonthSelected && isYearSelected,
            'text-(--text-placeholder)': !(isDaySelected && isMonthSelected && isYearSelected)
          }"> &nbsp; / &nbsp; </span>
                    <span [ngClass]="{
            'text-(--brand-primary)': currentSelectionTab === 'month',
            'text-(--text-secondary)': isMonthSelected && currentSelectionTab !== 'month',
            'text-(--text-placeholder)': !isMonthSelected && currentSelectionTab !== 'month'
          }">{{ month || 'MM' }}</span>
                    <span [ngClass]="{
            'text-(--text-secondary)': isDaySelected && isMonthSelected && isYearSelected,
            'text-(--text-placeholder)': !(isDaySelected && isMonthSelected && isYearSelected)
          }"> &nbsp; / &nbsp;</span>
                    <span [ngClass]="{
            'text-(--brand-primary)': currentSelectionTab === 'year',
            'text-(--text-secondary)': isYearSelected && currentSelectionTab !== 'year',
            'text-(--text-placeholder)': !isYearSelected && currentSelectionTab !== 'year'
          }">{{ year || 'YYYY' }}</span>
                </p>

                <!-- right arrow – go to next tab -->
                <button type="button" (click)="goPrevTab()" [disabled]="!canGoPrev"
                    class="rounded-full hover:bg-gray-100 disabled:opacity-50 disabled:cursor-auto transition-opacity order-3 rtl:order-1"
                    [attr.aria-label]="'Next ' + currentSelectionTab">
                    <img [src]="canGoPrev ? 'assets/icons/arrow-right-black.svg' : 'assets/icons/arrow-right-grey.svg'"
                        alt="arrow right" class="w-4 h-4" />
                </button>
            </div>

            <!-- ── YEAR TAB ── -->
            <div *ngIf="currentSelectionTab === 'year' && (options.defaultSelection === 'year' || options.defaultSelection === 'all')"
                class="mb-4">
                <div class="flex items-center">
                    <div class="w-8 rtl:order-3 order-1">
                        <button type="button" (click)="prevYearPage()" [disabled]="!canPrevYearPage"
                            class="p-1.5 rounded-full hover:bg-gray-100 disabled:opacity-50 disabled:cursor-auto transition-opacity"
                            aria-label="Previous years">
                            <img [src]="canPrevYearPage ? 'assets/icons/arrow-left-black.svg' : 'assets/icons/arrow-left-grey.svg'"
                                alt="arrow left" class="w-4 h-4" />
                        </button>
                    </div>

                    <!-- years -->
                    <div class="flex-1 order-2">
                        <div class="grid grid-cols-3 sm:grid-cols-4 gap-3">
                            <button type="button" *ngFor="let y of displayedYearRange" (click)="selectYear(y)"
                                class="px-3 py-1 h-10 rounded-full transition-all duration-200 w-full font-medium text-xl leading-7 disabled:text-(--text-placeholder) disabled:opacity-100"
                                [ngClass]="{
                      'bg-(--brand-primary) text-white': y === year,
                      'text-(--text-secondary) hover:bg-gray-50': y !== year && y !== currentYear
                    }">
                                {{ y }}
                            </button>
                        </div>
                    </div>

                    <div class="w-8 text-end rtl:order-1 order-3">
                        <button type="button" (click)="nextYearPage()" [disabled]="!canNextYearPage"
                            class="p-1.5 rounded-full hover:bg-gray-100 disabled:opacity-50 disabled:cursor-auto transition-opacity"
                            aria-label="Next years">
                            <img [src]="canNextYearPage ? 'assets/icons/arrow-right-black.svg' : 'assets/icons/arrow-right-grey.svg'"
                                alt="arrow right" class="w-4 h-4" />
                        </button>
                    </div>
                </div>
            </div>

            <!-- ── MONTH TAB ── -->
            <div *ngIf="currentSelectionTab === 'month' && (options.defaultSelection === 'month' || options.defaultSelection === 'all')"
                class="grid grid-cols-3 sm:grid-cols-4 gap-3 mb-4">
                <button type="button" *ngFor="let m of [0,1,2,3,4,5,6,7,8,9,10,11]" (click)="selectMonth(m)"
                    class="px-3 py-1 h-10 rounded-full transition-all duration-200 w-full font-medium text-xl leading-7 disabled:text-(--text-placeholder) disabled:opacity-100"
                    [ngClass]="{
                'bg-(--brand-primary) text-white': m === getMonthIndex(month),
                'text-(--text-secondary) hover:bg-gray-50': m !== getMonthIndex(month) && m !== currentMonthYear.month
              }">
                    {{ getMonthShortName(m) }}
                </button>
            </div>

            <!-- ── DAY GRID ── -->
            <div
                *ngIf="currentSelectionTab === 'day' && (options.defaultSelection === 'day' || options.defaultSelection === 'all')">
                <div class="grid grid-cols-7 gap-1 text-center text-sm">
                    <div *ngFor="let dayName of ['Su','Mo','Tu','We','Th','Fr','Sa']"
                        class="text-(--text-primary) font-semibold py-2 text-xl leading-7">
                        {{ dayName }}
                    </div>

                    <div *ngFor="let _ of [].constructor(firstDayOfMonth)" class="h-10"></div>

                    <button type="button" *ngFor="let d of daysInMonth" (click)="selectDay(d)"
                        class="h-10 w-10 rounded-full flex items-center justify-center transition-all duration-200 mx-auto text-(--text-primary) font-medium text-xl"
                        [ngClass]="{

                 'bg-(--brand-primary) text-white':
                  selectedDate?.getDate() === d &&
                  selectedDate?.getMonth() === currentMonthYear.month &&
                  selectedDate?.getFullYear() === currentMonthYear.year,

                'hover:bg-gray-50':
                  !(selectedDate?.getDate() === d && selectedDate?.getMonth() === currentMonthYear.month && selectedDate?.getFullYear() === currentMonthYear.year) &&
                  !(d === today.getDate() && currentMonthYear.month === today.getMonth() && currentMonthYear.year === today.getFullYear())
              }">
                        {{ d }}
                    </button>
                </div>
                <app-button [text]="'DATE_MODAL.CONFIRM' | translate" type="button" variant="primary" size="lg" extraClass="my-6"
                    (action)="moveToConfrimTab()" [disabled]="!selectedDate"></app-button>
            </div>
        </div>
    </div>

</div>